import React from "react";
import { ShieldAlert, ArrowRight } from "lucide-react";

export default function LockedFeatureGate({ featureName, navigate }) {
  return (
    <div className="plans-container" style={{ animation: "fadeIn 0.4s ease", display: "flex", justifyContent: "center", alignItems: "center", minHeight: "75vh" }}>
      <div className="card" style={{ maxWidth: "480px", padding: "40px", textAlign: "center", background: "rgba(239, 68, 68, 0.02)", border: "1px solid rgba(239, 68, 68, 0.15)", borderRadius: "20px", backdropFilter: "blur(12px)", boxShadow: "0 10px 40px rgba(239, 68, 68, 0.05)" }}>
        <div style={{
          width: "64px",
          height: "64px",
          background: "rgba(239, 68, 68, 0.08)",
          border: "2px solid rgba(239, 68, 68, 0.2)",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#ef4444",
          margin: "0 auto 24px auto"
        }}>
          <ShieldAlert size={32} />
        </div>
        <h3 style={{ fontSize: "20px", fontWeight: "900", color: "var(--text)", marginBottom: "12px" }}>
          Feature Locked
        </h3>
        <p style={{ color: "var(--text2)", fontSize: "14px", lineHeight: "1.6", marginBottom: "28px" }}>
          Your current plan or subscription validity does not authorize access to the <strong>{featureName}</strong> dashboard. Please renew or upgrade your package tier to unlock this feature.
        </p>
        <button 
          className="btn btn-primary" 
          onClick={() => navigate("/renew-plan")}
          style={{ width: "100%", justifyContent: "center", display: "flex", alignItems: "center", gap: "8px", padding: "12px", borderRadius: "10px", height: "42px", cursor: "pointer" }}
        >
          Upgrade Subscription Plan <ArrowRight size={16} />
        </button>
      </div>
    </div>
  );
}
